import dayjs from 'dayjs';

export const createOrderDateValue = () => dayjs();

export const parseOrderDateValue = (value) => dayjs(value, 'YYYYMMDD');

export const formatOrderDateValue = (value) => dayjs(value).format('YYYYMMDD');
